import Vue from "vue";
import WmIcon from "@wemade-vsf/icons/lib/runtime/components/WmIcon.mjs";
Vue.component("WmIcon", WmIcon);
